import { IsoTimestamp } from '../../..';

type AlbumId = string;
type UserId = string;

export type NotificationFrequency = 'hourly' | 'daily' | 'weekly';

export const NOTIFICATION_FREQUENCY_INTERVAL_MS: Record<NotificationFrequency, number> =
  Object.freeze({
    hourly: 60 * 60 * 1000,
    daily: 24 * 60 * 60 * 1000,
    weekly: 7 * 24 * 60 * 60 * 1000,
  });

export interface UserNotificationsConfig {
  enabled: boolean;
  allAlbums: boolean;
  albums: AlbumId[];
  lastNotifiedAt?: IsoTimestamp;
  notificationFrequency: NotificationFrequency;
}

export interface TeamNotificationsConfigEntity {
  subscribers: Record<UserId, UserNotificationsConfig>;
}
